/*
  Runtime accessibility fixes for issues the theme cannot fix in Liquid.

  1. Slider libraries (Flickity, Swiper) set aria-hidden="true" on off-screen
     slides at runtime, but leave links/buttons inside them keyboard focusable.
     Screen reader and keyboard users would tab into invisible content. This
     watches aria-hidden changes on slider cells and removes their focusable
     descendants from the tab order, restoring them when the slide is shown.

  2. Third-party apps inject iframes without a title attribute (e.g.
     #PBarNextFrame), failing the "frames must have a title" audit. Untitled
     iframes get a title derived from their id/name, or a generic fallback.
*/
(function () {
  var SLIDER_CONTAINERS = '.flickity-enabled, [data-flickity], .swiper, .announcment-bar-inner';
  var FOCUSABLE =
    'a[href], area[href], button:not([disabled]), input:not([disabled]), ' +
    'select:not([disabled]), textarea:not([disabled]), iframe, audio[controls], ' +
    'video[controls], [contenteditable]:not([contenteditable="false"]), [tabindex]';

  function setUnfocusable(el) {
    if (el.getAttribute('tabindex') === '-1') return;
    if (!el.hasAttribute('data-a11y-orig-tabindex')) {
      el.setAttribute('data-a11y-orig-tabindex', el.getAttribute('tabindex') || '');
    }
    el.setAttribute('tabindex', '-1');
  }

  function restoreFocusable(el) {
    if (!el.hasAttribute('data-a11y-orig-tabindex')) return;
    var orig = el.getAttribute('data-a11y-orig-tabindex');
    if (orig === '') {
      el.removeAttribute('tabindex');
    } else {
      el.setAttribute('tabindex', orig);
    }
    el.removeAttribute('data-a11y-orig-tabindex');
  }

  function syncCell(cell) {
    var hidden = cell.getAttribute('aria-hidden') === 'true';
    var focusables = cell.querySelectorAll(FOCUSABLE);
    for (var i = 0; i < focusables.length; i++) {
      hidden ? setUnfocusable(focusables[i]) : restoreFocusable(focusables[i]);
    }
    if (cell.matches(FOCUSABLE)) {
      hidden ? setUnfocusable(cell) : restoreFocusable(cell);
    }
  }

  function sweep(root) {
    var containers = (root || document).querySelectorAll(SLIDER_CONTAINERS);
    for (var i = 0; i < containers.length; i++) {
      var cells = containers[i].querySelectorAll('[aria-hidden]');
      for (var j = 0; j < cells.length; j++) syncCell(cells[j]);
    }
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var target = mutations[i].target;
      if (target.nodeType !== 1) continue;
      if (target.closest(SLIDER_CONTAINERS)) syncCell(target);
    }
  });

  function titleIframe(frame) {
    if (
      frame.hasAttribute('title') ||
      frame.hasAttribute('aria-label') ||
      frame.hasAttribute('aria-labelledby')
    ) {
      return;
    }
    // aria-hidden frames are exempt per WCAG, but strict scanners still
    // flag them (e.g. Shopify's web-pixel sandbox), so title them too.
    var idName = frame.id || frame.getAttribute('name') || '';
    if (/pixel|sandbox|analytics|track/i.test(idName)) {
      frame.setAttribute('title', 'Analytics measurement frame');
      return;
    }
    // Humanize the id/name, e.g. "PBarNextFrame" -> "PBar Next Frame";
    // drop hash-like tokens containing digits.
    var hint = idName
      .replace(/[-_]+/g, ' ')
      .replace(/([a-z\d])([A-Z])/g, '$1 $2')
      .replace(/\b\w*\d\w*\b/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    frame.setAttribute('title', hint || 'Embedded content');
  }

  function titleAllIframes() {
    var frames = document.querySelectorAll('iframe:not([title])');
    for (var i = 0; i < frames.length; i++) titleIframe(frames[i]);
  }

  var iframeObserver = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.tagName === 'IFRAME') {
          titleIframe(node);
        } else if (node.querySelector) {
          var frames = node.querySelectorAll('iframe:not([title])');
          for (var k = 0; k < frames.length; k++) titleIframe(frames[k]);
        }
      }
    }
  });

  function start() {
    observer.observe(document.body, {
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden'],
    });
    iframeObserver.observe(document.body, { subtree: true, childList: true });
    sweep();
    titleAllIframes();
    // Some sliders and app embeds initialize late (e.g. marquee via setTimeout)
    window.addEventListener('load', function () {
      setTimeout(function () {
        sweep();
        titleAllIframes();
      }, 1000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
